import {
  TALLY_SET_CONFIG,
  TALLY_SET_ACCOUNTS,
  TALLY_SET_CREDIT_NOTES,
  TALLY_SET_DEBIT_NOTES,
  TALLY_SET_JOURNAL_VOUCHERS,
  TALLY_SET_PRODUCTS,
  TALLY_SET_CUSTOMERS,
  TALLY_SET_INVOICES,
  TALLY_SET_BILLS,
  TALLY_SET_PAYMENTS,
  TALLY_SET_RECEIPTS,
  TALLY_SET_PURCHASE_ORDERS,
  TALLY_SET_SALES_ORDERS,
  TALLY_SET_GOODS_RECEIPT_NOTES,
  TALLY_SET_DELIVERY_NOTES
} from "../types";

const initialState = {
  config: {
    loading: true,
    data: {},
  },
  accounts: {
    loading: true,
    data: [],
  },
  creditNotes: {
    loading: true,
    data: {},
  },
  debitNotes: {
    loading: true,
    data: {},
  },
  journalVouchers: {
    loading: true,
    data: {},
  },
  tallyCustomers: {
    loading: false,
    data: {},
  },
  tallyProducts: {
    loading: false,
    data: {},
  },
  invoices: {
    loading: true,
    data: {},
  },
  bills: {
    loading: true,
    data: {},
  },
  payments: {
    loading: true,
    data: {},
  },
  receipts: {
    loading: true,
    data: {},
  },
  purchaseOrders: {
    loading: true,
    data: {},
  },
  salesOrders: {
    loading: true,
    data: {},
  },
  grnData: {
    loading: true,
    data: {},
  },
  deliveryNotes: {
    loading: true,
    data: {},
  },
};

function tallyReducer(state = initialState, action = {}) {
  switch (action.type) {
    case TALLY_SET_CONFIG:
      return {
        ...state,
        config: {
          loading: false,
          data: action.config,
        },
      };
    case TALLY_SET_ACCOUNTS:
      return {
        ...state,
        accounts: {
          loading: false,
          data: action.accounts,
        },
      };
    case TALLY_SET_CREDIT_NOTES:
      return {
        ...state,
        creditNotes: {
          loading: false,
          data: action.creditNotes,
        },
      };
    case TALLY_SET_DEBIT_NOTES:
      return {
        ...state,
        debitNotes: {
          loading: false,
          data: action.debitNotes,
        },
      };
    case TALLY_SET_JOURNAL_VOUCHERS:
      return {
        ...state,
        journalVouchers: {
          loading: false,
          data: action.journalVouchers,
        },
      };
    case TALLY_SET_PRODUCTS:
      return {
        ...state,
        tallyProducts: {
          loading: false,
          data: action.tallyProducts,
        },
      };
    case TALLY_SET_CUSTOMERS:
      return {
        ...state,
        tallyCustomers: {
          loading: false,
          data: action.tallyCustomers,
        },
      };
    case TALLY_SET_INVOICES:
      return {
        ...state,
        invoices: {
          loading: false,
          data: action.invoices,
        },
      };
    case TALLY_SET_BILLS:
      return {
        ...state,
        bills: {
          loading: false,
          data: action.bills,
        },
      };
    case TALLY_SET_PAYMENTS:
      return {
        ...state,
        payments: {
          loading: false,
          data: action.payments,
        },
      };
    case TALLY_SET_RECEIPTS:
      return {
        ...state,
        receipts: {
          loading: false,
          data: action.receipts,
        },
      };
    case TALLY_SET_PURCHASE_ORDERS:
      return {
        ...state,
        purchaseOrders: {
          loading: false,
          data: action.purchaseOrders,
        },
      };
    case TALLY_SET_SALES_ORDERS:
      return {
        ...state,
        salesOrders: {
          loading: false,
          data: action.salesOrders,
        },
      };
    case TALLY_SET_GOODS_RECEIPT_NOTES:
      return {
        ...state, 
        grnData:{
          loading: false,
          data: action.grnData
        }
      }  
    case TALLY_SET_DELIVERY_NOTES: 
    return {
      ...state,
      deliveryNotes: {
        loading: false,
        data: action.deliveryNotes,
      },
    };  
    default:
      return state;
  }
}

export default tallyReducer;
